import { lazyAppContext } from '@1inch-community/core/lazy';
export class PublicProxyClient {
    constructor() {
        this.context = lazyAppContext('PublicProxyClient');
    }
    get isAuth() {
        return true;
    }
    get host() {
        return this.context.value.environment.get('oneInchDevPortalHost');
    }
    get token() {
        return this.context.value.environment.get('oneInchDevPortalToken');
    }
    async init(context) {
        this.context.set(context);
    }
    async get(url) {
        const response = await fetch(this.getRequestUrl(url), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.token}`,
            },
        });
        return await response.json();
    }
    async post(url, body) {
        const response = await fetch(this.getRequestUrl(url), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.token}`,
            },
            body: JSON.stringify(body),
        });
        return await response.json();
    }
    getRequestUrl(urlPath) {
        const url = new URL(urlPath, this.host);
        url.pathname = url.pathname.replace(/\/+/g, '/');
        return url;
    }
}
//# sourceMappingURL=public-proxy-client.js.map